<div class="flex flex-col gap-4 p-4">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-default text-xl font-bold">Executive Dashboard</h1>
      <p class="text-secondary mt-0.5 text-sm">Platform-wide operational command center</p>
    </div>
  </div>

  <!-- Filter Bar -->
  <div class="rounded-xl border bg-white px-4 py-1">
    <app-global-filter-panel [config]="filterConfig" (filtersChanged)="onFiltersChanged($event)" />
  </div>

  <!-- Zone 1: Portfolio KPIs -->
  <app-kpi-card-grid [cards]="portfolioCards" title="PORTFOLIO OVERVIEW" [columns]="6" />

  <!-- Zone 1b: Financial Health -->
  <div class="rounded-xl border bg-white p-4">
    <h2 class="text-secondary mb-3 text-xs font-semibold uppercase tracking-wide">Financial Health</h2>
    <app-financial-summary-card [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'accounting_invoices_view'" />
  </div>

  <!-- Zone 2: Risk Register -->
  <div class="rounded-xl border bg-white p-4">
    <app-risk-register [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'associations_module'" />
  </div>

  <!-- Zone 2b: Work Queue + Approvals -->
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
    <div class="rounded-xl border bg-white p-4">
      <app-work-queue-list [filters]="filters" [requiredPermission]="'workorder_view'" />
    </div>
    <div class="rounded-xl border bg-white p-4">
      <app-approval-queue-list [requiredPermission]="'accounting_bills_approve'" />
    </div>
  </div>

  <!-- Zone 3: Performance + Contracts + Compliance -->
  <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
    <div class="rounded-xl border bg-white p-4">
      <app-performance-benchmark [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'reporting_financial'" />
    </div>
    <div class="rounded-xl border bg-white p-4">
      <app-contract-expiry-tracker [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'rfp_view'" />
    </div>
    <div class="rounded-xl border bg-white p-4">
      <app-compliance-tracker [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'compliance_report_view'" />
    </div>
  </div>

  <!-- Zone 5: Subscription Billing + Activity Timeline -->
  <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
    <div class="rounded-xl border bg-white p-4">
      <app-subscription-billing-card [dashboardType]="dashboardType" [filters]="filters" [requiredPermission]="'subscription_bills_view'" />
    </div>
    <div class="rounded-xl border bg-white p-4">
      <app-activity-timeline [filters]="filters" [requiredPermission]="'activity_logs_other'" />
    </div>
  </div>
</div>
